import React from 'react';
import {useForm} from 'react-hook-form';
import {FormShell} from 'components/form/FormShell';
import {EquipmentEditRow} from 'components/ui/EquipmentTable/EquipmentEditRow';
import {EquipmentRow} from 'components/ui/EquipmentTable/EquipmentRow';
import {EquipmentTable} from 'components/ui/EquipmentTable/EquipmentTable';
import {observer} from 'mobx-react-lite';
import {VehicleState} from 'store/vehicle/VehicleState';
import {CarEquipmentDto, GarageSpotEquipmentStatus} from '../../../../../../PRMGApiClient';

interface CarEquipmentProps {
  state: VehicleState;
}

const emptyEquipmentRow = {
  name: '',
  quantity: 0,
  status: GarageSpotEquipmentStatus.InStorage,
  description: '',
  addedDate: new Date(),
  location: '',
};

export const VehicleEquipmentFormTable: React.FunctionComponent<CarEquipmentProps> = observer(
  ({state}): JSX.Element => {
    const form = useForm<CarEquipmentDto>({
      defaultValues: {...emptyEquipmentRow, garageSpotId: state.item.garageSpot?.id},
    });
    const {handleSubmit, reset} = form;

    return (
      <FormShell>
        <EquipmentTable>
          <>
            {state.item.garageSpot?.carEquipment?.map((equipment) => (
              <EquipmentRow
                key={equipment.id}
                rowData={equipment}
                onDelete={(id) => state.removeCarEquipment(id)}
                onSave={(payload) => state.updateCarEquipment(payload)}
              />
            ))}
            <EquipmentEditRow
              form={form}
              onCancel={() => reset()}
              onConfirm={handleSubmit((payload) => state.addCarEquipment(payload).then(() => reset()))}
            />
          </>
        </EquipmentTable>
      </FormShell>
    );
  }
);
